import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-tick-icon',
  templateUrl: './lib-tick-icon.component.html',
  styleUrls: ['lib-tick-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibTickIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
